!<!--  -->
<template>
  <div class="nav srcNav">
    <div class="title">永嘉县水旱灾害防御平台</div>
    <div class="topright">
       <div class="rightitem" @click="back">
         <span style="display:inline-block"> 返回</span>
         <!-- <img src="@/assets/meiyu/back.png" alt="" /> -->
         <div class="el-icon-back" style="position:relative;bottom:5px;"></div>
      </div>
      <div class="time rightitem">
        <div class="time">{{nowTime}}</div>
        <div class="dateweek">
          <span>{{nowWeek}}</span>
          <span>{{nowDate}}</span>
        </div>
      </div>
      <!-- <div class="weather rightitem ">
        <div :style="'background:'+iconurl" style=" width: 35px; height: 28px;" class="weatherimg"></div>
        <span class="temp">
          {{temprature}}
          <span>℃</span>
        </span>
        <span class="weatherdesc">{{weatherDescribe}}</span>
      </div> -->
    </div>
    <!-- <div class="weather rightitem">
      <div :style="'background:'+iconurl" class="weatherimg"></div>
      <span class="temp">{{temprature}}<span>℃</span></span>
      <span class="weatherdesc">{{weatherDescribe}}</span>
    </div> -->
    <!-- <softwareDownLoad ref="softwareDownLoad"></softwareDownLoad> -->
  </div>
</template>

<script>
import WeatherDetail from '@/api/typhoonMap.js'
// import softwareDownLoad from './softwareDownLoad'
export default {
  props: ['choosed'],
  // components: { softwareDownLoad },
  data () {
    return {
      nowWeek: '',
      nowDate: '',
      nowTime: '',
      weatherDescribe: '',
      iconurl: '',
      temprature: ''
    }
  },
  computed: {},
  watch: {},
  methods: {
    back () {
      this.$router.push({
        path: '/nav'
      })
    },
    getWeatherInfo () {
      WeatherDetail.getWeatherInfo().then((data) => {
        this.weatherDescribe = data.data.detail.weatherDescribe
        this.temprature = data.data.detail.temprature
        this.iconurl = data.data.detail.now.webUrlWithPosition
      })
    },
    setNowTimes () {
      let myDate = new Date()
      let wk = myDate.getDay()
      let yy = String(myDate.getFullYear())
      let mm = myDate.getMonth() + 1
      let dd = String(
        myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate()
      )
      let hou = String(
        myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours()
      )
      let min = String(
        myDate.getMinutes() < 10
          ? '0' + myDate.getMinutes()
          : myDate.getMinutes()
      )
      let sec = String(
        myDate.getSeconds() < 10
          ? '0' + myDate.getSeconds()
          : myDate.getSeconds()
      )
      let weeks = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      ]
      let week = weeks[wk]
      this.nowDate = yy + '/' + mm + '/' + dd
      this.nowTime = hou + ':' + min + ':' + sec
      this.nowWeek = week
    }
  },
  created () {},
  mounted () {
    this.timer = setInterval(() => {
      this.setNowTimes()
    }, 1000)
    // this.getWeatherInfo()
  }
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.nav {
  width: 100%;
  background-image: url('~@/assets/homepage_img_ptcopy/top-bg.gif');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 65px;
  z-index: 999;
  position: relative;
  .title {
    font-size: 30px;
    height: 65px;
    line-height: 65px;
    font-weight: 700;
    color: #fff;
    margin-left: 70px;
    letter-spacing: 3px;
    display: inline-block;
    vertical-align: top;
  }
  .menu {
    display: inline-block;
    height: 65px;
    width: auto;
    color: #fff;
    line-height: 65px;
    // background: yellow;
    margin-left: 85px;
    .menuitem {
      font-size: 16px;
      width: 130px;
      text-align: center;
      height: 100%;
      float: left;
      cursor: pointer;
    }
    .menuactive {
      background-image: url('~@/assets/homepage_img_ptcopy/top-button.png');
      background-size: 75% 60%;
      background-position: center 13px;
      background-repeat: no-repeat;
    }
  }
  .topright {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 16px;
    display: inline-block;
    width: auto;
    color: #fff;
    // background: yellow;
    // .weather{
    //   display: flex;
    // }
    .rightitem {
      float: right;
      border-left: 1px #ddd solid;
      padding: 0 20px;
      height: 30px;
      line-height: 30px;
      >span{
        position: relative;
        bottom: 5px;
        padding-right: 5px;
      }
      .time {
        font-size: 24px;
        font-weight: 500;
        display: inline-block;
        vertical-align: top;
      }
      .dateweek {
        display: inline-block;
        margin-left: 5px;
        & > span {
          display: block;
          font-size: 12px;
          margin-top: -10px;
        }
      }
    }
    .rightitem:nth-child(3) {
      border: none;
    }
    .temp {
      font-size: 24px;
      vertical-align: super;
      & > span {
        font-size: 12px;
      }
    }
    .weatherimg {
      width: 35px;
      height: 35px;
      display: inline-block;
      // background: url('http://i.tq121.com.cn/c/weather2015/bluesky/../../../i/weather2015/png/white30.png') -160px 0;
      background-repeat: no-repeat;
    }
    .weatherdesc {
      font-size: 12px;
      margin-left: 7px;
      vertical-align: super;
    }
  }
}
.srcNav{
  .topright{
    &>div:nth-child(1){
      cursor: pointer;
      .el-icon-download{
        font-size: 22px;
      }
    }
  }
}
</style>
